export default __webpack_public_path__ + "static/media/location.79b68791.svg";